import React from 'react';
import { graphql } from 'gatsby';
import ProductSideBySide from './ProductSideBySide';
import { ProductPagePreview } from '../Global/DataUtils/productQueries';

import {
    KontentStringValue,
    KontentRadioMultiChoice,
    KontentRichText,
    CTAConfiguration,
} from '../../../types/KontentProps';
import { ProductFamily } from '../../templates/StructuredDataContext';
import { getMultiChoice } from '../Global/DataUtils';

type contentDisplayType = 'explicit' | 'relative';
type layoutDisplayType = 'carousel' | 'stacked';
type productSelectionType = 'use_product_family_tag' | 'use_products_attached';

export interface ProductSideBySideProps extends CTAConfiguration {
    headline: KontentStringValue;
    description: KontentRichText;
    selection_for_product_display: KontentRadioMultiChoice<productSelectionType>;
    content_display_type: KontentRadioMultiChoice<contentDisplayType>;
    layout_display_type?: KontentRadioMultiChoice<layoutDisplayType>;
    show_or_hide_cta?: KontentRadioMultiChoice<'show' | 'hide'>;
    cta_styling?: KontentRadioMultiChoice<'standard' | 'secondary'>;
    products: { value: ProductPagePreview[] };
    product_family: { value: ProductFamily[] };
    kontentItemId?: string;
}

const ProductSideBySideContainer: React.FC<ProductSideBySideProps> = (
    props
) => {
    const selectProducts = (): ProductPagePreview[] => {
        let selectedProducts = [] as ProductPagePreview[];

        if (
            getMultiChoice(props.selection_for_product_display) ===
            'use_product_family_tag'
        ) {
            selectedProducts =
                props.product_family?.value[0]?.elements?.products?.value;
        } else {
            selectedProducts = props.products?.value;
        }

        return selectedProducts;
    };

    const content = selectProducts();

    return <ProductSideBySide {...props} content={content} />;
};

export default ProductSideBySideContainer;

export const fragmentProductSideBySide = graphql`
    fragment ProductSideBySide on kontent_item_component___product_side_by_side {
        elements {
            description {
                value
            }
            headline {
                value
            }
            selection_for_product_display {
                value {
                    codename
                }
            }
            product_family {
                value {
                    ... on kontent_item_data___product_family {
                        elements {
                            product_family {
                                name
                                value {
                                    codename
                                    name
                                }
                                taxonomy_group
                                type
                            }
                            products {
                                value {
                                    ...productPagePreview
                                }
                            }
                        }
                    }
                }
            }
            products {
                value {
                    ...productPagePreview
                }
            }
            show_or_hide_cta {
                value {
                    codename
                }
            }
            cta_styling {
                value {
                    codename
                }
            }
            cta_configuration__cta_location_anchor_point {
                value
            }
            cta_configuration__cta_window_action {
                value {
                    codename
                }
            }
            cta_configuration__cta_location {
                ...kontentCtaLocation
            }
            cta_configuration__cta_label {
                value
            }
        }
    }
`;
